<template>
  <div style="padding: 20px 0px 0px 20px;">

    <el-form style="display: flex;flex-wrap: wrap;">
      <el-form-item label="老师姓名:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择老师" v-model="input1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="请假类型:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择审批状态" v-model="input3" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="部门:" style="display: flex;width: 33%;">
        <el-select style="width: 100%" v-model="resumeNumber3" popper-class="tree-select-popper"  ref="treeSelect">
            <el-option hidden :value="resumeNumber3"> </el-option>
            <el-tree
                :data="dataTrees"
                :props="defaultPropss"
                node-key="deptId"
                ref="treeSelect"
                :highlight-current="true"
                :check-on-click-node="true"
                @check="handleTreeCheck">
            </el-tree>
        </el-select>
      </el-form-item>



      <el-form-item label="审批状态:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择审批状态" v-model="input3" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="请假时间：" style="display: flex;margin-right: 20px;">
        <el-date-picker
          v-model="createTimeStart"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择开始时间"
          style="width: 200px;"
        ></el-date-picker>
        <span style="margin: 0px 10px;">至</span>
        <el-date-picker
          v-model="createTimeEnd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择结束时间"
          style="width: 200px;"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="提交时间：" style="display: flex;margin-right: 20px;">
        <el-date-picker
          v-model="completeTimeStart"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择开始时间"
          style="width: 200px;"
        ></el-date-picker>
        <span style="margin: 0px 10px;">至</span>
        <el-date-picker
          v-model="completeTimeEnd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择结束时间"
          style="width: 200px;"
        ></el-date-picker>
      </el-form-item>



      <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
        <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus"
          @click="searchAddBtns">添加审批人</el-button> -->
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"
          @click="searchBtns">搜索</el-button>
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"
          @click="clearBtns">清空</el-button>
      </div>

    </el-form>


    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700">
      <el-table-column prop="teacherName" label="老师姓名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralName" label="部门" show-overflow-tooltip></el-table-column>
      <el-table-column prop="applyForIntegral" label="请假类型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="请假时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="备注原因" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="提交时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="auditStatus" label="审批状态" show-overflow-tooltip>
        <template v-slot="scope">
          <div style="display: flex;justify-content: space-around;color:rgb(237 187 27);" v-if="scope.row.auditStatus === 0">未审批</div>
          <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);"  v-if="scope.row.auditStatus === 1">审批中</div>
          <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);" v-if="scope.row.auditStatus === 2">已审批</div>
          <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 3">已驳回</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template v-slot="scope">
          <div style="display: flex;justify-content: space-around;">
            <!-- <el-button type="text" :style="{
              color: scope.row.auditStatus === 2 || scope.row.auditStatus === 3 ? '#ccc' : '#00aaff'
            }"
            :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 3" @click="handleClickView('审批', scope.row)">审批</el-button>
            <el-button type="text" style="color:#00aaff;" @click="handleClickView('审批详情', scope.row)">审批详情</el-button> -->


            <el-button type="text" style="color:#00aaff;" @click="handleClickView('通过', scope.row)">通过</el-button>
            <el-button type="text" style="color:rgb(245 34 42);" @click="handleClickView('拒接', scope.row)">拒接</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
      :page-size="pageSize" layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>






    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="审批" :visible="showDomg" :before-close="showDomgcloseEditDialog" width="50%">


      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">提交说明:</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;pointer-events: none;" >
        <el-input style="width: 100%;" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" maxlength="300" show-word-limit  v-model="inputValuetextarea1"></el-input>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.auditStatus === 1">
        <div style="width: 80px;padding-top: 10px;">提交时间:</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;pointer-events: none;" v-if="itmeCopy.auditStatus === 1">
        <el-input style="width: 100%;"  maxlength="300"  v-model="createTime"></el-input>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.auditStatus === 1">
        <div style="width: 100px;padding-top: 10px;">一级审批建议:</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;pointer-events: none;" v-if="itmeCopy.auditStatus === 1">
        <el-input style="width: 100%;" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" maxlength="300" show-word-limit  v-model="itmeCopy.firstAuditOpinion"></el-input>
      </div>


      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.auditStatus === 1">
        <div style="width: 100px;padding-top: 10px;">一级审批时间:</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;pointer-events: none;" v-if="itmeCopy.auditStatus === 1">
        <el-input style="width: 100%;"   maxlength="300"  v-model="firstAuditDate"></el-input>
      </div>


      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">审批意见:</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <el-input style="width: 100%;" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" maxlength="300" show-word-limit  v-model="inputValuetextarea"></el-input>
      </div>


      <div style="display: flex; margin-bottom: 20px; justify-content: center;">
        <el-button  type="primary" size="small" class="btnss"   @click="handleClickViewBtn('驳回')">驳回</el-button>
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('通过')">通过</el-button>
      </div>


    </el-dialog>



    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="审批详情" :visible="showDomg1" :before-close="showDomg1closeEditDialog" width="50%">

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 100%;padding-top: 10px;">提交人:   {{ itmeCopy.teacherName }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 100%;padding-top: 10px;">提交说明:  {{ inputValuetextarea1 }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.createTime">
        <div style="width: 100%;padding-top: 10px;">提交时间:  {{ itmeCopy.createTime }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.firstApprove">
        <div style="width: 100%;padding-top: 10px;">一级审批人:   {{ itmeCopy.firstApproveName }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.firstAuditOpinion">
        <div style="width: 100%;padding-top: 10px;">一级审批意见:   {{ itmeCopy.firstAuditOpinion }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.firstAuditDate">
        <div style="width: 100%;padding-top: 10px;">一级审批时间:   {{ itmeCopy.firstAuditDate }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.secondApprove">
        <div style="width: 100%;padding-top: 10px;">二级审批人:   {{ itmeCopy.secondApproveName }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.secondAuditOpinion">
        <div style="width: 100%;padding-top: 10px;">二级审批意见:   {{ itmeCopy.secondAuditOpinion }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.secondAuditDate">
        <div style="width: 100%;padding-top: 10px;">二级审批时间:   {{ itmeCopy.secondAuditDate }}</div>
      </div>

    </el-dialog>




    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="添加审批人"  :visible="addShow" :before-close="closeEditDialog" width="70%">

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">一级审批人:</div>
        <div @click="handleClickAdd1" style="padding-top: 10px;"> <i  style="font-size: 20px;" class="el-icon-circle-plus"></i> </div>
      </div>


      <div style="margin-left: 60px;margin-bottom: 20px;">
          <div v-for="(itme,index) in oneLevelList" :key="index" style="margin-bottom: 40px;">

            <div @click="handleClickRemove1(index)" style="padding-top: 10px; position: absolute;left: 50px;margin-top: 2px;"> <i  style="font-size: 20px;" class="el-icon-remove"></i> </div>

            <div style="display: flex; margin-bottom: 20px;">
              <div style="width: 80px;padding-top: 10px;">审批人:</div>
              <el-select placeholder="请选择审批状态" v-model="itme.approve" style="width: 100%" clearable filterable multiple>
                <el-option v-for="item in optionList2" :key="item.id" :value="item.id" :label="item.realname"></el-option>
              </el-select>
            </div>

            <div style="display: flex; margin-bottom: 20px;">
              <div style="width: 80px;padding-top: 10px;">项目名称:</div>
              <el-select placeholder="请选择审批状态" v-model="itme.integralName" style="width: 100%" clearable filterable multiple>
                <el-option v-for="item in optionList5" :key="item.id" :value="item.id" :label="item.integralName"></el-option>
              </el-select>
            </div>

          </div>
      </div>



      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">二级审批人:</div>
        <div @click="handleClickAdd2" style="padding-top: 10px;"> <i  style="font-size: 20px;" class="el-icon-circle-plus"></i> </div>
      </div>


      <div style="margin-left: 60px;">
          <div v-for="(itme,index) in twoLevelList" :key="index" style="margin-bottom: 40px;">

            <div @click="handleClickRemove2(index)" style="padding-top: 10px; position: absolute;left: 50px;margin-top: 2px;"> <i  style="font-size: 20px;" class="el-icon-remove"></i> </div>

            <div style="display: flex; margin-bottom: 20px;">
              <div style="width: 80px;padding-top: 10px;">审批人:</div>
              <el-select placeholder="请选择审批状态" v-model="itme.approve" style="width: 100%" clearable filterable multiple>
                <el-option v-for="item in optionList2" :key="item.id" :value="item.id" :label="item.realname"></el-option>
              </el-select>
            </div>

            <div style="display: flex; margin-bottom: 20px;">
              <div style="width: 80px;padding-top: 10px;">项目名称:</div>
              <el-select placeholder="请选择审批状态" v-model="itme.integralName" style="width: 100%" clearable filterable multiple>
                <el-option v-for="item in optionList5" :key="item.id" :value="item.id" :label="item.integralName"></el-option>
              </el-select>
            </div>

          </div>
      </div>


      <div style="display: flex; margin-bottom: 20px; justify-content: end;">
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('取消')">取消</el-button>
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('确定')">确定</el-button>
      </div>


    </el-dialog>





    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false"  :title="showDomgrTextis + '审批'"  :visible="showDomgr" :before-close="closeshowDomgrEditDialog" width="70%">


      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">{{showDomgrTextis}}原因:</div>
        <el-input style="width: 100%;" type="textarea"  :autosize="{ minRows: 10, maxRows: 10 }" maxlength="999999" show-word-limit  v-model="showDomgrText"></el-input>
      </div>

      <div style="display: flex; margin-bottom: 20px; justify-content: end;">
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn11('取消')">取消</el-button>
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn11('确定')">确定</el-button>
      </div>

    </el-dialog>



  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { getTeachers } from "@/api/fiveClassApi"


export default {
  components: {

  },
  data() {
    return {
      itmeCopy:'',
      inputValuetextarea:'',

      inputValue1: '',
      inputValue2: 0 ,
      inputValue3: '',

      Titlecenter: '添加积分项目',
      optionList4: [{ id: 0, name: '无效' }, { id: 1, name: '有效' }],

      optionList1: [],
      optionList2: [],
      optionList3: [
        { id: 0, name: '未审批' },
        { id: 1, name: '审批中' },
        { id: 2, name: '审批成功' },
        { id: 3, name: '审批驳回' }
      ],

      input1: '',
      input2: '',
      input3: '',

      dataList: [],

      pageNum: 1,
      pageSize: 10,
      total: 0,

      createTimeStart: '',
      createTimeEnd: '',
      completeTimeStart: '',
      completeTimeEnd: '',

      showDomgr: false,
      showDomgrText: '',

      CourseCancellationComponentsType: '',
      CourseCancellationComponentsID: '',
      CourseCancellationComponentsShow: false,

      CourseCancellationomponentsTypeDistinguish: '课消审批',


      dataTrees:[],
      defaultPropss:{ children: 'children', label: 'deptName' },

      addShow: false,

      inputID:'',


      showDomg:false,
      showDomg1:false,

      oneLevelList:[],
      twoLevelList:[],

      optionList5:[],

      inputValuetextarea1:'',


      createTime:'',
      firstAuditopinion:'',
      firstAuditDate:'',

      resumeNumber3Id:'',
      resumeNumber3:'',


      showDomgrTextis:'',

    }
  },

  mounted() {
    axios.get(`${apiBaseUrl}/teacher/teacherAllList `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      this.optionList1 = res.data.data
    })
    axios.get(`${apiBaseUrl}/teacher/teacherAllList `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
      this.optionList2 = res.data.data
    })

    axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTrees = res.data.data})

    this.handleintegralProject()
    this.getApiList()
  },


  methods: {

    handleTreeCheck(e){
      this.resumeNumber3 = e.deptName
      this.resumeNumber3Id = e.deptId
      this.$refs.treeSelect.visible = false
    },
    handleintegralProject(){
      axios.post(`${apiBaseUrl}/integralProject/findList`, { integralName:'' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.optionList5 = data
        } else {
          this.optionList5 = []
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },


    handleClickRemove1(index){
      this.oneLevelList.splice(index,1)
    },

    handleClickRemove2(index){
      this.twoLevelList.splice(index,1)
    },
    handleClickAdd1(){
      this.oneLevelList.push({})
    },

    handleClickAdd2(){
      this.twoLevelList.push({})
    },

    processItem(item,type){
      item.approveRank =  type
      item.approve = (item.approve && item.approve.length > 0) ? item.approve.join(',') : null
      item.integralName = (item.integralName && item.integralName.length > 0) ? item.integralName.join(',') : null
      return item
    },


    handleClickViewBtn11(type){
      if(type === '取消'){
        this.showDomgr = false
        this.showDomgrText = ''
      }
      if(type === '确定'){
        if(this.showDomgrText){
          this.showDomgr = false
          this.showDomgrText = ''
        }else{
          this.$message.warning('请输入(  ' + this.showDomgrTextis + '  )原因')
        }

      }
    },

    handleClickViewBtn(type){

      if(type === '取消'){
          this.inputValue1 = ''
          this.inputValue2 = 0
          this.inputValue3 = ''
          this.Titlecenter = ''
          this.inputID = ''
          this.oneLevelList = []
          this.twoLevelList = []
          this.addShow = false
      }

      if(type === '确定'){


          // let newOneLevelList =  this.oneLevelList.map((itme)=>{
          //     itme.approveRank = 1
          //     itme.approve = (itme.approve && itme.approve.length > 0) ? itme.approve.join(',') : null
          //     itme.integralName = (itme.integralName && itme.integralName.length > 0) ? itme.integralName.join(',') : null
          //     return itme
          // })

          // let newTwoLevelList = this.twoLevelList.map((itme)=>{
          //     itme.approveRank = 2
          //     itme.approve = (itme.approve && itme.approve.length > 0) ? itme.approve.join(',') : null
          //     itme.integralName = (itme.integralName && itme.integralName.length > 0) ? itme.integralName.join(',') : null
          //     return itme
          // })




          let newOneLevelList = []

          this.oneLevelList.map((itemv) => {
            newOneLevelList.push(this.processItem(itemv,1))
          })

          let newTwoLevelList = []
          this.twoLevelList.map((itemv) => {
            newTwoLevelList.push(this.processItem(itemv,2))
          })

          let data = [...newOneLevelList, ...newTwoLevelList]




          axios.post(`${apiBaseUrl}/integralApprove/addAndUpdate`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {

            if (res.data.code === 200) {

                this.oneLevelList = []
                this.twoLevelList = []

                this.$message({ message:res.data.message, type: "success" })
                this.addShow = false

                this.getApiList()

            } else {

              this.$message.error(res.data.message)
              this.oneLevelList = []
              this.twoLevelList = []
              this.addShow = false
            }
          }).catch((err) => {
            this.$message.error(err)
          })

      }


      if(type === '驳回'){
        this.$confirm('确定要驳回此条信息吗?, 是否继续?', '提示', {  confirmButtonText: '确定', cancelButtonText: '取消',  type: 'warning' }).then(() => {

            let data = null

            if(this.itmeCopy.auditStatus === 0 || this.itmeCopy.auditStatus === '0'){
              data = {  id: this.itmeCopy.id,  firstAuditOpinion: this.inputValuetextarea, firstAuditStatus: 2,  }
            }

            if(this.itmeCopy.auditStatus === 1 || this.itmeCopy.auditStatus === '1'){
              data = {  id: this.itmeCopy.id,  secondAuditOpinion: this.inputValuetextarea, secondAuditStatus: 2,  }
            }

            axios.post(`${apiBaseUrl}/integralAudit/audit`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
              if (res.data.code === 200) {
                this.inputValuetextarea = ''
                this.$message({ message:res.data.message, type: "success" })
                this.showDomg = false
              } else {
                this.$message.error(res.data.message)
              }
            }).catch((err) => {
              this.$message.error(err)
            })

        })
      }


      if(type === '通过'){
        this.$confirm('确定要通过此条信息吗?, 是否继续?', '提示', {  confirmButtonText: '确定', cancelButtonText: '取消',  type: 'warning' }).then(() => {

          let data = null

            if(this.itmeCopy.auditStatus === 0 || this.itmeCopy.auditStatus === '0'){
              data = {  id: this.itmeCopy.id,  firstAuditOpinion: this.inputValuetextarea, firstAuditStatus: 1,  }
            }

            if(this.itmeCopy.auditStatus === 1 || this.itmeCopy.auditStatus === '1'){
              data = {  id: this.itmeCopy.id,  secondAuditOpinion: this.inputValuetextarea, secondAuditStatus: 1,  }
            }

            axios.post(`${apiBaseUrl}/integralAudit/audit`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
              if (res.data.code === 200) {
                this.inputValuetextarea = ''
                this.$message({ message:res.data.message, type: "success" })
                this.showDomg = false
              } else {
                this.$message.error(res.data.message)
              }
            }).catch((err) => {
              this.$message.error(err)
            })

        })
      }

    },

    searchAddBtns() {
      this.Titlecenter = '添加积分项目'


      axios.get(`${apiBaseUrl}/integralApprove/findList`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {

            if (res.data.code === 200) {
              let data = res.data.data
              if(data && data.length > 0){

                data.map((item)=>{

                  if(item.approveRank === 1 || item.approveRank === '1'){
                    item.approve = item.approve ? item.approve.split(",").map(Number) : []
                    item.integralName = item.integralName ? item.integralName.split(",").map(Number) : []

                    this.oneLevelList.push(item)
                  }

                  if(item.approveRank === 2 || item.approveRank === '2'){
                    item.approve = item.approve ? item.approve.split(",").map(Number) : []
                    item.integralName = item.integralName ? item.integralName.split(",").map(Number) : []

                    this.twoLevelList.push(item)
                  }

                })
              }

            } else {
              this.$message.error(res.data.message)
            }
          }).catch((err) => {
            this.$message.error(err)
      })


      this.addShow = true
    },

    closeshowDomgrEditDialog(){
        this.showDomgr = false
        this.showDomgrText = ''
    },

    closeEditDialog() {
      this.Titlecenter = ''
      this.inputValue1 = ''
      this.inputValue2 = 0
      this.inputValue3 = ''
      this.inputID = ''
      this.oneLevelList = []
      this.twoLevelList = []
      this.addShow = false
    },

    CourseCancellationhandleEmit(e) {
      this.CourseCancellationComponentsShow = e
    },

    searchBtns() {
      this.getApiList()
    },

    clearBtns() {
      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
      this.input4 = ''


      this.createTimeStart =  ''
      this.createTimeEnd =  ''
      this.completeTimeStart =  ''
      this.completeTimeEnd =  ''

      this.getApiList()
    },

    getApiList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        teacherId: this.input1,
        integralId: this.input2,
        auditStatus: this.input3,
      }
      axios.post(`${apiBaseUrl}/integralAudit/findPage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList = data.records
          this.pageNum = data.current ? data.current : 0
          this.pageSize = data.size ? data.size : 10
          this.total = data.total ? data.total : 0

          this.$message({ message:res.data.message, type: "success" });
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleSizeChange(e) {
      this.pagepageSizeNum = e
      this.getApiList()
    },

    handleCurrentChange(e) {
      this.pageNum = e
      this.getApiList()
    },

    showDomgcloseEditDialog() {
      this.showDomg = false
    },

    showDomg1closeEditDialog() {
      this.showDomg1 = false
    },
    handleClickView(type, itme) {

      this.itmeCopy = itme

      if (type === '审批') {
          this.inputValuetextarea1 = itme.auditExplain
          this.createTime = itme.createTime
          this.firstAuditopinion = itme.firstAuditopinion
          this.firstAuditDate = itme.firstAuditDate
          this.showDomg = true
      }


      if (type === '审批详情') {
          this.inputValuetextarea1 = itme.auditExplain
          this.showDomg1 = true
      }


      if (type === '编辑') {
        console.log(itme)
        this.Titlecenter = '编辑积分项目'

        this.inputValue1 = itme.inputValue1
        this.inputValue2 = itme.inputValue2
        this.inputValue3 = itme.inputValue3
        this.inputID = itme.id

        this.addShow = true

      }

      if(type === '详情'){
        this.CourseCancellationComponentsType = type
        this.CourseCancellationComponentsID = itme.id
        this.CourseCancellationComponentsShow = true

        this.$nextTick(() => {
          this.$refs.CourseCancellationomponents.handleInit(itme.id)
        })
      }


      if(type === '通过' || type === '拒接'){
         this.showDomgr = true
         this.showDomgrTextis = type
      }


    },


  }

}
</script>


<style scoped lang="less">

.btnss{
  background-color: #d80b2a;
  border-color: #d80b2a;
}
.no-click {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/LeaveApproval/LeaveApproval.vue